import InfoService from '@/api/admin/info.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    sectionGroupModel: {},
  },
  getters: {
    getSectionGroups: state => state.table,
    getSectionGroupModel: state => state.sectionGroupModel,
  },
  actions: {
    async getSectionGroups({ commit }) {
      const sectionGroups = await InfoService.getSectionGroups()
      commit('SET_SECTION_GROUPS', sectionGroups)
    },
  },
  mutations: {
    SET_SECTION_GROUPS(state, sectionGroups) {
      state.table.rows = sectionGroups
    },

    SET_SECTION_GROUP_MODEL(state, sectionGroup) {
      state.sectionGroupModel = sectionGroup
    },
  },
}
